import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, tap } from 'rxjs';
import { ApiService } from '@app/core/services/api/api.service';
import { QueryParameters } from '@app/core/entities/query-parameters.class';
import { DeliverCursorPaginationService } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.service';
import { DeliverCursorPagination } from '@app/services/deliver-cursor-pagination/deliver-cursor-pagination.model';
import { PreviewOrdersActions } from '../store/actions';
import { TABLES } from '@utils/table.utils';

@Injectable()
export class VerifyCursorPaginationService extends DeliverCursorPaginationService<DeliverCursorPagination.VerifyTabCounters> {
  private apiService = inject(ApiService);
  private store = inject(Store);

  table = TABLES.VERIFY;

  protected fetchOrdersFromApi(
    params: DeliverCursorPagination.OrdersRequest,
  ): Observable<DeliverCursorPagination.OrdersResponse> {
    return this.apiService.post('order/v2/orders', params).pipe(
      tap((response) => {
        this.store.dispatch(
          PreviewOrdersActions.loadPreviewOrdersSuccess({
            orders: response.orders,
            count: response.orders.length,
          }),
        );
      }),
    );
  }

  protected fetchCountFromApi(query: QueryParameters): Observable<DeliverCursorPagination.CappedCount> {
    return this.apiService.post('order/v2/count', query);
  }

  protected fetchTabCountersFromApi(): Observable<DeliverCursorPagination.VerifyTabCounters> {
    return this.apiService.get('order/v2/tab-count/verify');
  }
}
